export default "__VITE_ASSET__DTLFLzvv__"